import { IStandardHeadlineSize, StandardHeadlineSize } from 'app_previous/elements/typography/heading.styles';
import { IStandardParagraphSize, StandardParagraphSize } from 'app_previous/elements/typography/paragraph.styles';
import { layout } from 'app_previous/styles/layout';
import { FlattenSimpleInterpolation, css } from 'styled-components';

const getCompleteFontSizeStylesByStandardSize = (standardSize: IStandardParagraphSize | IStandardHeadlineSize) => {
  const { desktop, lg, sm } = standardSize;

  return css`
    font-size: ${desktop};

    ${!lg
      ? ''
      : css`
          @media screen and (max-width: ${layout.lg}) {
            font-size: ${lg};
          }
        `}

    ${!sm
      ? ''
      : css`
          @media screen and (max-width: ${layout.sm}) {
            font-size: ${sm};
          }
        `}
  `;
};

const getParagraphDefaultStyles = (): FlattenSimpleInterpolation => {
  const defaultSizes = StandardParagraphSize['1.125'];

  return css`
    p.ast-p-element {
      font-family: Inter, sans-serif;
      ${getCompleteFontSizeStylesByStandardSize(defaultSizes)}
    }
  `;
};

const getHeadline1DefaultStyles = (): FlattenSimpleInterpolation => {
  const defaultSizes = StandardHeadlineSize['3.375'];

  return css`
    h1.ast-h1-element {
      font-family: InterTight, Arial, sans-serif;
      ${getCompleteFontSizeStylesByStandardSize(defaultSizes)}
    }
  `;
};

const getHeadline2DefaultStyles = (): FlattenSimpleInterpolation => {
  const defaultSizes = StandardHeadlineSize['2.5'];

  return css`
    h2.ast-h2-element {
      font-family: InterTight, Arial, sans-serif;
      ${getCompleteFontSizeStylesByStandardSize(defaultSizes)}
    }
  `;
};

const getHeadline3DefaultStyles = (): FlattenSimpleInterpolation => {
  const defaultSizes = StandardHeadlineSize['2.125'];

  return css`
    h3.ast-h3-element {
      font-family: InterTight, Arial, sans-serif;
      ${getCompleteFontSizeStylesByStandardSize(defaultSizes)}
    }
  `;
};

const getHeadline4DefaultStyles = (): FlattenSimpleInterpolation => {
  const defaultSizes = StandardHeadlineSize['1.5'];

  return css`
    h4.ast-h4-element {
      font-family: InterTight, Arial, sans-serif;
      ${getCompleteFontSizeStylesByStandardSize(defaultSizes)}
    }
  `;
};

const getHeadline5DefaultStyles = (): FlattenSimpleInterpolation => {
  const defaultSizes = StandardHeadlineSize['1.25'];

  return css`
    h5.ast-h5-element {
      font-family: InterTight, Arial, sans-serif;
      ${getCompleteFontSizeStylesByStandardSize(defaultSizes)}
    }
  `;
};

const getOrderedListItemDefaultStyles = (): FlattenSimpleInterpolation => {
  return css`
    ol.ast-ol-element {
      br {
        /* Remove extra spacing from Safari */
        display: none;
      }
    }
  `;
};

const getUnorderedListItemDefaultStyles = (): FlattenSimpleInterpolation => {
  return css`
    ul.ast-ul-element {
      br {
        /* Remove extra spacing from Safari */
        display: none;
      }
    }
  `;
};

const getListItemDefaultStyles = (): FlattenSimpleInterpolation => {
  const defaultSizes = StandardParagraphSize['1.125'];

  return css`
    li.ast-li-element {
      font-family: Inter, sans-serif;
      ${getCompleteFontSizeStylesByStandardSize(defaultSizes)}
    }
  `;
};

export const getDefaultTextStyles = (): FlattenSimpleInterpolation => {
  return css`
    ${getParagraphDefaultStyles()}
    ${getHeadline1DefaultStyles()}
    ${getHeadline2DefaultStyles()}
    ${getHeadline3DefaultStyles()}
    ${getHeadline4DefaultStyles()}
    ${getHeadline5DefaultStyles()}
    ${getOrderedListItemDefaultStyles()}
    ${getUnorderedListItemDefaultStyles()}
    ${getListItemDefaultStyles()}
  `;
};
